import { Box, styled, Typography } from '@mui/material';
import { palette } from 'view/themes/palette';

export const TextWrapper = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: '4px',
  marginBottom: '24px',
}) as typeof Box;

export const TextTitle = styled(Typography)({
  color: palette.text.header,
  fontSize: '18px',
  fontWeight: 700,
  lineHeight: '130%',
}) as typeof Typography;

export const TextSubTitle = styled(Typography)({
  color: palette.unknown.sub_title_grey,
  fontWeight: 400,
  fontSize: '14px',
  lineHeight: '19.04px',
}) as typeof Typography;

export const Separator = styled(Box)({
  height: '1px',
  backgroundColor: palette.border.default,
  margin: '32px 0',
}) as typeof Box;

export const RemovableContainer = styled(Box)({
  width: '100%',
  marginBottom: '16px',
}) as typeof Box;

export const RemovableContainerHeader = styled(Box)({
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  marginBottom: '16px',
}) as typeof Box;

export const RemovableContainerHeaderTitle = styled(Typography)({
  color: palette.text.placeholder,
  fontWeight: 600,
  fontSize: '14px',
  lineHeight: '18px',
  textTransform: 'uppercase',
}) as typeof Typography;

export const RemovableContainerHeaderDeleteBtn = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  padding: '4px 0',
  cursor: 'pointer',

  svg: {
    path: {
      fill: palette.alerts.error,
    },
  },
  span: {
    color: palette.alerts.error,
    fontWeight: 600,
    fontSize: '16px',
    lineHeight: '20px',
  },
}) as typeof Box;

export const DateContainer = styled(Box)({
  width: '100%',
  /* display: 'flex',
  alignItems: 'center',
  gap: '8px',
  padding: '4px 0',
  cursor: 'pointer', */
}) as typeof Box;

export const DateLabel = styled(Typography)<{ error?: boolean }>(({ error }) => {
  return {
    color: error ? palette.alerts.error : palette.text.header,
    fontSize: '16px',
    fontWeight: 600,
    lineHeight: '128%',
  };
});

export const DateSelectWrapper = styled(Box)({
  width: '100%',
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'space-between',
  gap: '8px',
}) as typeof Box;
